/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

/**
 * Tab-state controller for the targeting editor.
 * Targeting widgets still register against this object.
 */
export class TargetingTabController {
  private readonly tabs: Record<string, {reg: () => void; copy?: (template: any) => void}> = {};
  private readonly beforeSubmits: Array<() => any> = [];
  private readonly allTabSelects: Array<() => void> = [];
  onAction: (() => void) | undefined;

  constructor(onAction?: () => void) {
    this.onAction = onAction;
  }

  register = (key: string, select: () => void, copyFunc?: (template: any) => void): void => {
    this.tabs[key] = {
      reg: select,
      copy: copyFunc
    };
  };

  registerAllTabs = (func: () => void): void => {
    this.allTabSelects.push(func);
  };

  callBeforeSubmit = (func: () => any): void => {
    this.beforeSubmits.push(func);
  };

  copyTargetingTemplate = (key: string, template: any, fallback?: () => void): void => {
    const copy = _.get(this.tabs, [key, 'copy']);
    if (_.isFunction(copy)) {
      copy(template);
    } else if (_.isFunction(fallback)) {
      fallback();
    }
    this.execOnAction();
  };

  onTabSelect = (key: string, prepareCurrent = true): void => {
    if (prepareCurrent) {
      _.forEach(this.allTabSelects, (func) => func());
    }
    (_.get(this.tabs, [key, 'reg']) || _.noop)();
    this.execOnAction();
  };

  tabBeforeSubmit = (): Promise<any> => {
    const pending = _.map(this.beforeSubmits, (func) => Promise.resolve(func()));
    return Promise.all(pending).then(() => this.execOnAction());
  };

  private execOnAction(): void {
    if (_.isFunction(this.onAction)) {
      this.onAction();
    }
  }
}
